const logoUrl = "https://customer-assets-wrfwihn1.emergentagent.net/job_guardian-core-5/artifacts/f47zp7fv_COIGuardian-logo.png";
const markUrl = "https://customer-assets-wrfwihn1.emergentagent.net/job_guardian-core-5/artifacts/7upfl7vy_icon-512.png";

export function Brand({ compact = false, light = false }) {
  return (
    <div className="flex items-center" data-testid="coiguardian-brand">
      <img
        alt="COIGuardian"
        className={compact ? "h-14 w-14 object-contain" : "h-16 w-auto object-contain"}
        data-testid="coiguardian-logo"
        src={compact ? markUrl : light ? "https://customer-assets-wrfwihn1.emergentagent.net/job_guardian-core-5/artifacts/0kopdhf8_COIGuardian-logo-white.png" : logoUrl}
      />
    </div>
  );
}